import React, { useState } from 'react';
import {
  Container,
  Input,
  Form,
  Button,
  Alert,
  FormGroup,
  Label,
  Col,
  FormFeedback,
} from 'reactstrap';
import { requestPasswordReset } from '../api/user';
import validateEmailAddress from '../utils/validateEmailAddress';

function PasswordResetRequestForm() {
  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState(false);
  const [complete, setComplete] = useState(false);
  // const [errorMessage, setErrorMessage] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      requestPasswordReset({ email: email.trim().toLowerCase(), app: process.env.NEXT_PUBLIC_APP });
      setSubmitting(false);
      setComplete(true);
    } catch (error) {
      // setErrorMessage(error.message);
      setSubmitting(false);
    }
  };

  if (complete)
    return (
      <Container>
        <Alert color="success" className="sticky-top text-center">
          Email verstuurd
        </Alert>
        <p className="my-5 text-center">
          Indien je e-mailadres bij ons bekend is, ontvang je zo meteen een e-mail met instructies
          om een nieuw wachtwoord in te stellen.
        </p>
      </Container>
    );

  return (
    <Form onSubmit={submitHandler} className="w-75 px-lg-5">
      <fieldset disabled={submitting}>
        <FormGroup row>
          <Label for="email" sm={4} size="lg">
            E-mail
          </Label>
          <Col sm={8}>
            <Input
              autoComplete="email"
              type="text"
              required
              id="email"
              name="email"
              bsSize="lg"
              placeholder="Email"
              onChange={({ target }) => {
                setEmail(target.value);
                setTouched(true);
              }}
              valid={!!(touched && validateEmailAddress(email))}
              invalid={!!(touched && !validateEmailAddress(email))}
            />
          </Col>
          <FormFeedback>Geef een geldig e-mail adres in</FormFeedback>
        </FormGroup>
        <div className="d-flex justify-content-center">
          <Button
            className="mt-4"
            type="submit"
            color="primary"
            disabled={!validateEmailAddress(email)}
          >
            Nieuw wachtwoord aanvragen
          </Button>
        </div>
      </fieldset>
    </Form>
  );
}

export default PasswordResetRequestForm;
